module.exports = __webpack_public_path__ + "static/img/modulo_rele_1_canal_5v-2.de56210.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/modulo_rele_1_canal_5v-2.svg
// module id = VC3i
// module chunks = 0